import React, { useContext, useEffect, useState } from 'react';
import { Button, Col, DatePicker, Flex, Form, Input, Row, Select, Tabs, Tooltip } from 'antd';
import { useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import { Badge } from 'flowbite-react';
import dayjs from 'dayjs';
import StatusComponent from '../../globalComponents/StatusComponent';
import { quotationProductColumns, poColumns } from '../utils/tableColumns';
import EditableTable from '../../globalComponents/EditableTable';
import EventEmitter from '../../utils/eventEmitter';
import usePurchaseOrderAPI from '../apis/purchaseOrdersAPI';
import SmartButton from '../../globalComponents/SmartButton';
import { MdReceiptLong } from "react-icons/md";
import AuthContext from '../../utils/AuthContext';





const PurchaseOrderChanges = () => {
  const [form] = Form.useForm();
  const { user } = useContext(AuthContext);
  const { success, error, CustomBreadcrumb } = useOutletContext();
  const { products, contacts, operationTypes, purchaseOrder } = useLoaderData();
  purchaseOrder['order_deadline_date'] = purchaseOrder.order_deadline_date ? dayjs(purchaseOrder['order_deadline_date'], 'YYYY-MM-DD HH:mm') : '';
  purchaseOrder['expected_arrival_date'] = purchaseOrder.expected_arrival_date ? dayjs(purchaseOrder['expected_arrival_date'], 'YYYY-MM-DD HH:mm') : '';
  const params = useParams();
  const navigate = useNavigate();
  const { create, update, confirm } = usePurchaseOrderAPI();
  const [productQuotations, setProductQuotations] = useState(purchaseOrder.number ? purchaseOrder.orderlines : []);
  // const [taxes, setTaxes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);


  
  const handleSubmit = async() => {
    let data = form.getFieldsValue();
    data['order_deadline_date'] = new Date(data.order_deadline_date);
    data['expected_arrival_date'] = new Date(data.order_deadline_date);
    data['orderlines'] = productQuotations;
    data['buyer'] = user.id;
    data['tax_total_price'] = form.getFieldValue('tax_total_price');
    create(data, success);
    // console.log(data)
  }

  const handleUpdate = async() => {
    let data = form.getFieldsValue();
    // update(analytic.seo, data, success);
    // console.log(data)
  }

  const handleMartAsToDo = async (status) => {
    let data = form.getFieldsValue();
    data['status'] = status;
    data['order_deadline_date'] = new Date(data.order_deadline_date).toISOString();
    data['expected_arrival_date'] = new Date(data.order_deadline_date).toISOString();
    update(purchaseOrder.number.replaceAll('/', '-'), data, success);
    // console.log(data)
  }

  const confirmOrder = async () => {
    try {
      setIsLoading(true);
      await confirm(purchaseOrder.number, purchaseOrder);
      setIsLoading(false);
    }catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }

  // console.log(products)
  useEffect(() => {
    EventEmitter.subscribe('purchase_rfq_created', data => {
      navigate('/purchase/purchase-orders/'+data.replaceAll('/', '-'));
    });

    EventEmitter.subscribe('purchase_order_confirmed', data => {
      
      navigate('/purchase/purchase-orders/'+data.replaceAll('/', '-'));
    })

    EventEmitter.subscribe('tax_total_price', data => {
      const total = data.reduce((prev, current) => (current.amount + prev), 0);
      form.setFieldValue('tax_total_price', total);
    });


    return () => {
      EventEmitter.unsubscribe('purchase_rfq_created');
      EventEmitter.unsubscribe('tax_total_price');
      EventEmitter.unsubscribe('purchase_order_confirmed');
    }
  },[]);
 

  // useEffect(() => {
  //   fetch('http://localhost:7900/taxes/all/sales-taxes', {
  //     method: 'GET',
  //     credentials: 'include'
  //   })
  //   .then(res => res.json()) 
  //   .then(res => setTaxes(res))
  //   .catch(err => console.log(err))
  // },[]) 
  // console.log(taxes)
  const addLine = () => { 
    let array = [...productQuotations];
    let obj = {
      key: productQuotations.length,
      product_id: '',
      description: ' ',
      quantity: 1,
      packaging_quantity: 0,
      packaging_id: '',
      price: 0,
      received_quantity: 0,
      billed_quantity: 0,
      tax_id: [],
      received_quantity_subtotal: 0,
      subtotal: 0
    };
    if (purchaseOrder.status !== 'purchase_order') {
      delete obj.billed_quantity;
      delete obj.received_quantity;
      delete obj.received_quantity_subtotal;
    } 
    array.push(obj);
    setProductQuotations(array);
    
  };
  // console.log(productQuotations)

  const receiveProducts = () => {
    navigate(`/purchase/purchase-orders/${params.action}/transfers`);
  }

  return (
    <div className='container mx-auto' style={{maxWidth: '1200px'}}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <CustomBreadcrumb />
            {/* <Link to={'/purchase/purchase-orders'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Purchase Orders</Link> / {params.action} */}
          </h3>
          <Tooltip title={'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleSubmit} type='text' htmlType='button'
              disabled={ purchaseOrder.number ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
        {purchaseOrder.number && 
        <div className='flex justify-between bg-white'>
          <Flex wrap='wrap' align='center' gap={'small'} style={{maxWidth: '70%'}}>
            {purchaseOrder.status === 'rfq' && 
              <>
                <Button size='small' loading={isLoading} disabled={isLoading} type='primary' className='font-semibold bg-[#189aa0] hover-btn' onClick={confirmOrder}>CONFIRM ORDER</Button>
                <Button size='small' type='text' className='font-semibold text-[#189aa0]'>CANCEL</Button>
              </>
            }
              <>
              {purchaseOrder.status === 'purchase_order' && 
              <Button size='small' type='primary' className='font-semibold bg-[#189aa0] hover-btn' onClick={receiveProducts}>RECEIVE PRODUCTS</Button>}
              {(purchaseOrder.status === 'received') && <Button size='small' type='text' className='font-semibold bg-[#189aa0]'>CREATE BILL</Button>}
              </>
          </Flex>
          <StatusComponent formValue={purchaseOrder} name={'purchase order'}/>
        </div>
        }
        
      </div>
      <div className='mt-5 bg-white shadow'>
        {purchaseOrder.status === 'purchase_order' && <Flex className='border-b m-0' justify='flex-end'>
          <SmartButton icon={<MdReceiptLong size={'1.4rem'} />} number={0} text={'Receipt'} className='border-s-2' />
        </Flex>}
        <Form   
          form={form}
          className='p-3'
          labelAlign='left'
          labelCol={{span: 7}}
          initialValues={purchaseOrder.number ? purchaseOrder :
            {}
          }
          variant='borderless'
          disabled={purchaseOrder.status === 'purchase_order' ? true : false}
        >
          <Row>
            <Col md={{span: 11}}>
              <Form.Item label={'Vendor'} name={'vendor_id'} className='font-bold mb-1' required>
                <Select options={contacts.map(contact => ({value: contact.id, label: contact.name,}))} className='font-normal' />
              </Form.Item>
              <Form.Item label='Vendor Reference' name={'vendor_reference'} className='font-bold mb-1' required>
                <Input type='text' className='font-normal input-outline-none' />
              </Form.Item>
              
            </Col>
            <Col md={{span: 11, offset: 1}}>
              <Form.Item label='Order Deadline' name={'order_deadline_date'} className='font-bold mb-1' required>
                <DatePicker showTime format={'YYYY-MM-DD HH:mm'} className='font-normal w-full'/>
              </Form.Item>
              <Form.Item label='Expected Arrival' name={'expected_arrival_date'} className='font-bold mb-1' required>
                <DatePicker showTime format={'YYYY-MM-DD HH:mm'} className='font-normal w-full'/>
              </Form.Item>
              <Form.Item label='Deliver To' name={'deliver_to'} className='font-bold mb-1' required>
                <Select options={operationTypes.map(operation => ({value: operation.id, label: operation.name, }))} className='font-normal' />
              </Form.Item>
            </Col>
          </Row>
          <Tabs 
            type='card'
            items={[
              {
                key: 1,
                label: 'Products',
                children: 
                <EditableTable
                  products={products}
                  taxes={[]}
                  dataSource={productQuotations}
                  setDataSource={setProductQuotations}
                  addLine={addLine}
                  columns={(purchaseOrder.status === 'purchase_order' || purchaseOrder.status === 'received') ?  poColumns : quotationProductColumns}
                  disabled={(purchaseOrder.status === 'purchase_order' || purchaseOrder.status === 'received') ? true : false}
                />
              },
              {
                key: '2',
                label: 'Other Information',
                forceRender: true,
                children: 
                  <Row>
                    <Col md={{span: 11}}>
                      <Badge className="text-slate-500 text-sm bg-transparent	border-b-2 mb-3">SHIPPING INFORMATION</Badge> 
                      <Form.Item label='Buyer' className='font-bold mb-1' required>
                        <Input type='text' readOnly value={user.user} className='font-normal input-outline-none' />
                      </Form.Item>
                      <Form.Item label='Source Document' name={'tracking_reference'} className='font-bold mb-1' required>
                        <Input type='text' className='input-outline-none font-normal' />
                      </Form.Item>
                    </Col>
                    
                  </Row>
                
              },
              {
                key: '3',
                label: 'Alternatives',
                forceRender: true,
                children: 
                  <></>
              }
            ]}
          />          
        </Form>
      </div>
    </div>
  )
}
export default PurchaseOrderChanges;